var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-product-tile__colors-selector" },
    [
      _c(
        "swiper",
        {
          ref: "swiper",
          attrs: {
            config: _vm.swiperConfig,
            "initial-slide": 0,
            navigation: true,
          },
          scopedSlots: _vm._u([
            {
              key: "navigationprev",
              fn: function () {
                return [
                  _c("rb-lazy-icon", {
                    staticClass: "--no-click",
                    attrs: { icon: "caret-light-left", text: "caret-big-left" },
                  }),
                ]
              },
              proxy: true,
            },
            {
              key: "navigationnext",
              fn: function () {
                return [
                  _c("rb-lazy-icon", {
                    staticClass: "--no-click",
                    attrs: {
                      icon: "caret-light-right",
                      text: "caret-big-rights",
                    },
                  }),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(" "),
          _vm._v(" "),
          _vm._l(_vm.colors, function (color, index) {
            return _c("swiper-slide", { key: index }, [
              _c(
                "button",
                {
                  staticClass: "rb-product-tile__color-variant",
                  class: {
                    "rb-product-tile__color-variant--selected":
                      _vm.selectedIndex === index,
                    "--no-click": _vm.isPlpExclusive,
                  },
                  attrs: {
                    "data-element-id": _vm.dataElementIdLabel,
                    tabindex: _vm.colorVariantTabIndex,
                    "aria-label": "color variant",
                  },
                  on: {
                    mouseover: function () {
                      return _vm.actionOnSlide(index, !_vm.isPlpExclusive)
                    },
                    focusin: function () {
                      return _vm.actionOnSlide(index, !_vm.isPlpExclusive)
                    },
                    click: function () {
                      return _vm.actionOnSlide(index, _vm.isPlpExclusive)
                    },
                  },
                },
                [
                  _c("rb-lazy-media", {
                    class: { "--no-click": _vm.isPlpExclusive },
                    attrs: {
                      src: _vm.addParams(color.images.primary),
                      "force-load": true,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "custom-element-image",
                          fn: function () {
                            return [
                              _c("rb-dummy-skeleton", {
                                staticClass: "--image-loading",
                                attrs: { icon: "assets" },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ])
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }